<button type="button" (click)="closeModal('Cross click')" class="btn-close" aria-label="Close" tabindex="-1"></button>
<ng-content></ng-content>
